module.exports = __webpack_public_path__ + "img/img_half_futanoura_1.7ac0cdb2.png";